
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  dashboard: "Tableau de bord",
  templates: "Modèles",
  workflow: "Flux de travail",
  content: "Contenu",
  company: "Entreprise",
  Communication: "Communication",
  Staff: "Personnel",
  created_at: "Date de création",
  Checklist: "Liste de contrôle",
  Settings: "Paramètres",
  activity_log: "Journal d'activité",
  name: "Nom",
  staff_mang: "Gestion du personnel",
  Edit_btn: "Bouton Modifier",
  create_staff: "Créer Personnel",
  update_staff: "Modifier Personnel",
  delete: "Supprimer",
  edit: "Modifier",
  create: "Créer",
  update: "Mettre à jour",
  cancel: "Annuler",
  role: "Rôle",
  plce_role: "Veuillez saisir le rôle",
  role_rule: "Veuillez sélectionner le rôle",
  action: "Action",
  phone_no: "Téléphone",
  phone_rule: "Veuillez saisir un numéro de téléphone valide",
  plce_phoneno: "Saisir téléphone",
  email: "Email",
  plce_email: "Saisir email",
  email_rule: "Veuillez saisir l'email",
  lastname: "Nom de famille",
  lname_rule: "Veuillez saisir le nom de famille",
  plce_lastname: "Saisir nom de famille",
  plce_firstname: "Saisir prénom",
  fname_rule: "Veuillez saisir le prénom",
  firstname: "Prénom",
  Create_temp: "Créer modèle",
  update_temp: "Mettre à jour modèle",
  active: "Actif",
  submit: "Soumettre",
  approvars: "Approbateurs",
  addnew: "Ajouter nouveau",
  view: "Voir",
  title: "Titre",
  single: "Simple",
  multiple: "Multiple",
  inp_type: "Type d'entrée",
  grid_type: "Type de grille",
  selec_type: "Sélectionner le type de vue",
  placeholder: "Espace réservé",
  plce_grid: "Sélectionnez votre type de grille",
  plce_type: "Sélectionnez votre type d'entrée",
  plce_title: "Saisir titre",
  ent_plce: "Saisir espace réservé",
  rule_grid: "Veuillez sélectionner le type de grille!",
  rule_type: "Veuillez sélectionner le type de modèle!",
  rule_title: "Veuillez saisir votre titre",
  options: "Options",
  Add_field: "Ajouter champ",
  options_rule: "Veuillez saisir le nom des options",
  option_name: "Saisir nom d'option",
  val_type: "Type de valeur",
  ent_info: "Saisir info",
  ent_label: "Saisir étiquette",
  ent_field: "Saisir nom de champ",
  info: "Info",
  required: "Requis",
  add_attribute: "Ajouter attribut",
  create_workflow: "Créer flux de travail",
  workflow_name: "Nom",
  workflow_type: "Type",
  description: "Description",
  checklist: "Liste de contrôle",
  company_rule: "Veuillez! saisir un nom d'entreprise",
  select: "Sélectionner",
  plce_company: "Sélectionner un nom d'entreprise",
  desc_rule: "Veuillez saisir une description",
  workflow_type_rule: "Veuillez sélectionner le type de flux de travail",
  workflow_rule: "Sélectionner un type de flux de travail",
  plce_workflow: "Saisir un nom de flux de travail",
  plce_workflow_type: "Saisir un type de flux de travail",
  plce_checklist: "Sélectionner une liste de contrôle",
  create_work: "Aller à créer flux de travail",
  con_Content: "Contenu du contrat",
  create_content: "Créer Contenu",
  update_content: "Mettre à jour Contenu",
  content_name: "Nom du Contenu",
  content_type: "Type de Contenu",
  plce_content_type: "Saisir type",
  content_type_rule: "Veuillez saisir un type de contenu",
  content_name_rule: "Veuillez saisir un nom de contenu",
  plce_content_name: "Saisir nom",
  content_rule: "Veuillez saisir un contenu",
  plce_content: "Saisir un contenu",
  create_company: "Créer Entreprise",
  company_name: "Nom de l'Entreprise",
  address: "Adresse",
  pincode: "Code postal",
  categoryId: "Id Catégorie",
  update_company: "Mettre à jour entreprise",
  cname_rule: "Veuillez saisir un nom d'entreprise",
  cname_placeholder: "Saisir Nom d'Entreprise",
  address_rule: "Veuillez saisir une adresse d'entreprise",
  plce_address: "Saisir adresse",
  plce_pincode: "Saisir code postal",
  pincode_rule: "Veuillez saisir un code postal",
  workflow_Services: "Services de Flux de travail",
  template_Services: "Services de Modèles",
  content_Services: "Services de Contenu",
  workflowtype_Services: "Services de Type de flux de travail",
  option_rule: "Option requise",
  category_name: "Nom de Catégorie",
  create_category: "Créer Catégorie",
  update_category: "Mettre à jour Catégorie",
  categoryname: "Nom de catégorie",
  category_rule: "Veuillez! saisir un nom de catégorie",
  rule_description: "Veuillez saisir une description",
  plce_description: "Saisir une description",
  category: "Catégorie",
  plce_category: "Saisir une catégorie",
  create_checklist: "Créer liste de contrôle",
  update_checklist: "Mettre à jour liste de contrôle",
  checklist_name: "Nom de liste de contrôle",
  contentType: "Type de Contenu",
  contractType: "Type de Contrat",
  contentType_rule: "Veuillez saisir un type de contenu.",
  contractType_rule: "Veuillez saisir un type de contrat.",
  plce_contentType: "Saisir un type de contenu",
  plce_contractType: "Saisir un type de contrat",
  create_contentType: "Créer Type de Contrat",
  update_contentType: "Mettre à jour Type de Contrat",
  selecttemp: "Sélectionner un modèle",
  selectcontent: "Sélectionner un contenu",
  close: "Fermer",
  create_Approval: "Créer Approbation",
  add_approval: "Ajouter Approbation",
  levelname: "Nom du Niveau",
  strategy: "Stratégie",
  update_workflow: "Mettre à jour Flux de travail",
  update_password: "Mettre à jour Mot de passe",
  enter_comment: "Saisir Commentaire",
  Template: "Modèle",
  template: "Modèles",
  levelname_rule: "Veuillez saisir le nom du niveau",
  plce_levelname: "Saisir nom du niveau",
  workflow_typename: "Nom du Type de flux de travail",
  workflow_type_delete: "Êtes-vous sûr de vouloir supprimer ce Type de flux de travail?",
  yes: "Oui",
  no: "Non",
  change: "Changer",
  create_workflow_type: "Créer Type de Flux de travail",
  update_workflow_type: "Mettre à jour Type de Flux de travail",
  workflow_type_name: "Nom du type de flux de travail",
  workflowtype_rule: "Veuillez! saisir un nom de type de flux de travail",
  plce_workflowtype: "Veuillez saisir le nom du flux de travail",
  TimelineComment: "Chronologie/Commentaire",
  please_select_template: "Veuillez sélectionner le modèle",
  please_select_content: "Veuillez sélectionner le contenu",
  please_select_checklist: "Veuillez sélectionner la liste de contrôle",
  approval: "Approbation",
  profile: "Profil",
  resetpassword: "Réinitialiser Mot de passe",
  reset: "Réinitialiser",
  Userdetails: "Détails de l'Utilisateur",
  updatepassword: "Mettre à jour Mot de passe",
  vendor: "Fournisseur",
  vendors: "Fournisseurs",
  vendor_mang: "Gestion des Fournisseurs",
  create_vendor: "Créer Fournisseur",
  firstName: "Prénom",
  lastName: "Nom de famille",
  save: "Sauvegarder",
  phoneno: "Téléphone",
  gender: "Sexe",
  update_vendor: "Mettre à jour Fournisseur",
  agrrement_management: "Gestion des Accords",
  refresh: "Actualiser",
  task_management: "Gestion des Tâches",
  create_task: "Créer Tâche",
  update_task: "Mettre à jour Tâche",
  task: "Tâche",
  taskname: "Nom de Tâche",
  startdate: "Date de début",
  enddate: "Date de fin",
  taskname_rule: "Veuillez saisir un nom de tâche",
  plce_taskname: "Saisir un nom de tâche",
  plce_enddate: "Sélectionner date de fin",
  enddate_rule: "Veuillez sélectionner la date de fin",
  plce_startdate: "Sélectionner date de début",
  startdate_rule: "Veuillez sélectionner la date de début",
  task_details: "Détails de la Tâche",
  company_delete_title: "Êtes-vous sûr de supprimer cette Entreprise?",
  content_delete_title: "Êtes-vous sûr de vouloir supprimer ce Contenu?",
  field_delete_title: "Êtes-vous sûr de vouloir supprimer ce champ?",
  contenttype_delete_titte: "Êtes-vous sûr de vouloir supprimer ce Type de contenu?",
  category_delete_title: "Êtes-vous sûr de supprimer cette Catégorie?",
  vendor_delete_title: "Êtes-vous sûr de vouloir supprimer ce Fournisseur?",
  task_delete_title: "Êtes-vous sûr de vouloir supprimer cette tâche?",
  approval_delete_title: "Êtes-vous sûr de vouloir supprimer cette Approbation?",
  checklist_delete_titte: "Êtes-vous sûr de vouloir supprimer cette Liste de contrôle?",
  search_: "Rechercher...",
  new_password: "Nouveau Mot de passe",
  new_password_rule: "Veuillez saisir votre nouveau mot de passe!",
  new_password_plce: "Saisir Nouveau Mot de passe",
  confirm_password_plce: "Confirmer votre Mot de passe",
  confirm_password_rule: "Veuillez confirmer votre mot de passe!",
  password_not_match: "Les deux mots de passe que vous avez saisis ne correspondent pas!",
  confirm_password: "Confirmer Mot de passe",
  company_details: "Détails de l'Entreprise",
  workflow_delete_title: "Êtes-vous sûr de vouloir supprimer ce Flux de travail?",
  staff_delete_title: "Êtes-vous sûr de vouloir supprimer ce Personnel?",
  staff_delete_title_contract: "Êtes-vous sûr de vouloir supprimer ce contrat?",
  template_delete_title: "Êtes-vous sûr de vouloir supprimer ce Modèle?",
  WorkflowType: "Type de Flux de travail",
  comments: "Commentaires",
  detailview: "Vue détaillée",
  task_name: "Nom de la Tâche",
  status: "Statut",
  task_template_name: "Nom du modèle de tâche",
  Select_vendor: "Sélectionner fournisseur",
  please_select_vendor: "Veuillez sélectionner le fournisseur",
  please_select_staff: "Veuillez sélectionner le personnel",
  forgot_password: "Mot de passe oublié",
  data_not_found: "Données Non Trouvées",
  new_password_rules: "Le mot de passe doit contenir 6-16 caractères",
  new_password_patternrules: "Votre mot de passe doit contenir des lettres majuscules et minuscules, au moins un chiffre, au moins un caractère spécial, et être entre 8 et 16 caractères. Veuillez réessayer.",
  new_password_patternrules_new: "Votre mot de passe doit contenir des lettres majuscules et minuscules, au moins un chiffre, au moins un caractère spécial, et être entre 8 et 16 caractères. Veuillez réessayer.",
  confirm_password_checkrule: "Les mots de passe ne correspondent pas, veuillez retaper",
  edit_comment: "Modifier Commentaire",
  rule_label: "Veuillez saisir une étiquette",
  rule_datatype: "Veuillez sélectionner un type de données",
  company_owner_detail: "Détails du propriétaire de l'entreprise",
  Enter_Comment_here: "Saisir commentaire ici",
  pleaseEnterComment: "Veuillez saisir un commentaire",
  today: "Aujourd'hui",
  tomorrow: "Demain",
  yesterday: "Hier",
  edit_content: "Modifier Contenu",
  edit_template: "Modifier modèle",
  basic_details: "Détails de base",
  fields_details: "Détails des champs",
  next: "Suivant",
  previous: "Précédent",
  Accept: "Accepter",
  rule_category: "Veuillez! sélectionner la catégorie",
  login: "Connexion",
  forget_your_password: "Mot de passe oublié?",
  password: "Mot de passe",
  password_rule: "Veuillez saisir votre mot de passe!",
  useremail_rule: "Veuillez saisir votre email utilisateur!",
  useremail: "Email utilisateur",
  plce_workflow_task: "Sélectionner un type de flux de travail",
  noDataFound: "Aucune donnée trouvée",
  wait: "Attendre",
  no_record_found: "Aucun Enregistrement Trouvé",
  workflow_management: "Gestion du flux de travail",
  logout: "Déconnexion",
  super_admin: "Super Administrateur",
  step: "Étape",
  step_1: "Étape 1",
  step_2: "Étape 2",
  step_3: "Étape 3",
  input_comment_rule: "Veuillez saisir un commentaire",
  select_all: "Tout sélectionner",
  checklist_detail: "Détails de la Liste de contrôle",
  content_detail: "Détails du Contenu",
  template_detail: "Détails du Modèle",
  approval_detail: "Détails de l'Approbation",
  changepassword: "Changer mot de passe",
  plce_strategy: "Sélectionner stratégie",
  please_strategy: "Veuillez sélectionner la stratégie",
  level: "Niveau",
  reject: "Rejeter",
  task_managementVendor: "Gestion des Tâches Fournisseur",
  selectchecklist: "Sélectionner liste de contrôle",
  Otp: "OTP",
  otp_rule: "Saisir un OTP",
  new_otp_plce: "Saisir OTP",
  plce_select_company: "Sélectionner entreprise",
  workflow_approve_title: "Approuver le flux de travail?",
  approve: "Approuver",
  Content_Checklist: "Liste de contrôle du Contenu",
  content_selection: "Sélection de Contenu",
  workflow_accept_title: "Accepter le flux de travail?",
  type: "Type",
  pending: "En attente",
  progress: "Progrès",
  completed: "Terminé",
  signature_required: "Signature requise",
  checklist_item: "Élément de liste de contrôle",
  parameterized: "Paramétré",
  assign: "Assigner",
  assign_workflow: "Assigner flux de travail",
  mycontract: "Mes Contrats",
  kyc: "KYC",
  created_by: "Créé par",
  download: "Télécharger",
  email_valid_rule: "Saisir email valide",
  comment: "Commentaire",
  total: "Total",
  created_content: "Contenu créé",
  approve_content: "Approuver contenu",
  created_workflow: "Flux de travail créé",
  assigned_workflow: "Flux de travail assigné",
  approvedWorkflow: "Flux de travail approuvé",
  inprogress: "En cours",
  pendingtasks: "Tâche en attente",
  total_template: "Total modèle",
  total_content: "Total Contenu",
  total_workflow: "Total Flux de travail",
  total_task: "Total tâche",
  task_detail: "Détails de la tâche",
  workflow_detail: "Détails du Flux de travail",
  content_details: "détails du contenu",
  email_must_rule: "Veuillez saisir l'email",
  Template_Fields: "Champs du Modèle",
  clear: "Effacer",
  total_company: "Total Entreprises",
  accepted_content: "Contenus Acceptés",
  rejection_comment: "Commentaire de Rejet",
  contractexpiry: "Expiration du contrat",
  rule_contractexpiry: "Veuillez saisir l'expiration du contrat",
  type_of_input: "Type d'entrée",
  type_your_signature: "Tapez votre Signature",
  default_fields: "Champs par Défaut",
  enterdigit: "Saisir chiffre",
  please_select: "Veuillez sélectionner une option",
  default_field: "Champs par défaut",
  key: "Clé",
  sample_content: "Contenu d'exemple",
  create_SampleContent: "Créer contenu d'exemple",
  content_title: "Titre",
  update_SampleContent: "Mettre à jour contenu d'exemple",
  notification: "Notification",
  plce_select_sample: "Sélectionner échantillon",
  review_comment: "Commentaires de révision",
  expire_on: "Expire le",
  my_contracts: "Mes contrats",
  my_task: "Ma Tâche",
  staff: "Personnel",
  Select_staff: "Sélectionner Personnel",
  Activation_date: "Date d'Activation",
  expire_date: "Date d'Expiration",
  create_new: "Créer nouveau",
  workflow_popupconfirm_title: "Êtes-vous sûr de vouloir soumettre le flux de travail?",
  taskname_contractname: "Nom",
  designation: "Désignation",
  designation_placeholder: "Saisir Désignation",
  contract: "Contrat",
  create_template: "Créer Modèle",
  create_date: "Date de Création",
  filter: "Filtres",
  content_no: "N° de Contenu",
  template_no: "N° de Modèle",
  workflow_no: "N° de Flux de travail",
  popup: "Popup",
  total_templates: "Modèle(s)",
  total_contents: "Contenu(s)",
  total_workflows: "Flux de travail",
  total_companys: "Entreprise(s)",
  content_types: "Type de Contenu",
  total_tasks: "Tâche(s)",
  assigned_company: "Entreprise(s) Assignée(s)",
  fill_vendor_detail: "Remplir Détails du Fournisseur",
  workflow_reject_title: "Rejeter flux de travail",
  Assign_vendors: "Fournisseurs Assignés",
  vendor_details: "Détail du Fournisseur",
  other_Services: "Autres Services",
  preference: "Préférence",
  companyName: "Nom de l'Entreprise",
  Task_popupconfirm_title: "Êtes-vous sûr de vouloir approuver?",
  ApprovedTask: "Approuvé",
  signInProgress: "Signature en cours",
  company_content: "Contenu de l'Entreprise",
  open: "Ouvert",
  expired: "Expiré",
  enable: "Activer",
  disable: "Désactiver",
  inactive: "Inactif",
  active_confirm_title: "Êtes-vous sûr de vouloir activer cette entreprise?",
  inactive_confirm_title: "Êtes-vous sûr de vouloir désactiver cette entreprise?",
  enable_confirm_title: "Êtes-vous sûr de vouloir activer la licence de cette entreprise?",
  disable_confirm_title: "Êtes-vous sûr de vouloir désactiver la licence de cette entreprise?",
  task_datasubmit_title: "Votre date d'entrée en vigueur et votre date d'exécution sont-elles identiques?",
  renew_task_datasubmit_title: "Votre date d'entrée en vigueur est-elle identique à la date d'expiration du contrat original?",
  task_datasubmit_execution_title: "votre date d'entrée en vigueur est identique à la date d'exécution",
  renew_task_datasubmit_execution_title: "votre date d'entrée en vigueur sera la date d'expiration du contrat original",
  content_validation: "Vous n'avez pas utilisé certains champs du Modèle. Êtes-vous sûr de vouloir soumettre le Contenu?",
  task_datasubmit_executionafter_title: "votre date d'entrée en vigueur sera",
  import: "Importer",
  create_bulk_task: "Créer Tâche en Lot",
  sample_excel_file: "Fichier Excel d'Exemple",
  file: "Fichier",
  import_SampleContent: "Importer contenu d'exemple",
  import_contentType: "Importer type de contrat",
  import_category: "Importer Catégorie",
  import_workflow_type: "Importer type de flux de travail",
  import_checklist: "Importer Liste de contrôle",
  Ok: "Ok",
  enable_licence: "Activer Licence",
  disable_licence: "Désactiver Licence",
  activate: "Activer",
  deactivate: "Désactiver",
  start_date: "Date de début",
  end_date: "Date de fin",
  effective_date: "Date d'entrée en vigueur",
  execution_date: "Date d'exécution",
  contract_expiry: "Expiration du Contrat",
  phone_number: "Numéro de Téléphone",
  dob: "Date de naissance",
  age: "Âge",
  Workflow_key: "Clé du Flux de travail",
  effective_execution_date_same: "Date d'entrée en vigueur et d'exécution identique",
  level_1: "Niveau 1",
  task_start_date: "Date de début de tâche",
  task_end_date: "Date de fin de tâche",
  secretAccessKey: "Clé d'Accès Secrète",
  keyId: "Id de Clé",
  storageType: "Type de Stockage",
  Select_Email: "Sélectionner Email",
  premium_features: "Fonctionnalités Premium",
  company_premium_features: "Fonctionnalités Premium de l'Entreprise",
  bulk_task: "Tâche en Lot",
  awsBucketRegion: "Région du Bucket AWS",
  awsBucketName: "Nom du Bucket AWS",
  storagetype_confirm_title: "À partir de maintenant, vos données seront stockées dans le bucket fourni",
  tlp_storageType: "Sélectionnez votre type de stockage",
  tlp_key_id: "L'ID de Clé AWS est un identifiant unique pour accéder à votre stockage dans AWS. Il peut être obtenu depuis le tableau de bord de votre compte AWS.",
  tlp_secretAccessKey: "La Clé d'Accès Secrète AWS est une clé confidentielle utilisée pour l'authentification et l'accès à votre stockage AWS. Assurez-vous de la garder sécurisée et évitez de la partager.",
  tlp_awsBucketName: "Le Nom du Bucket AWS fait référence au nom unique de votre bucket de stockage dans AWS. Il est utilisé pour identifier et accéder au bucket spécifique où vos données sont stockées.",
  tlp_awsBucketRegion: "La Région du Bucket AWS représente la région géographique où votre bucket de stockage est situé. Elle détermine l'emplacement physique où vos données sont stockées.",
  user_details: "Détails de l'Utilisateur",
  access_key_id: "Id de Clé d'Accès",
  upload_request: "Demande de téléchargement",
  change_request: "Demande de changement",
  update_request: "Demande de mise à jour",
  changes_history: "Historique des Changements",
  template_history: "Historique du Modèle",
  history: "Historique",
  upload_request_title: "Que voulez-vous changer?",
  content_: "Contenu",
  changes: "Changements",
  review_changes: "Réviser les changements",
  historical_contract: "Contrats Historiques",
  create_historical_contract: "Créer Contrat Historique",
  update_historical_contract: "Mettre à jour Contrat Historique",
  contract_name: "Nom du Contrat",
  contract_type: "Type de Contrat",
  parties_name: "Nom des Parties",
  parties_address: "Adresse de la Partie",
  expiry_date: "Date d'expiration",
  form_name: "Nom du Formulaire",
  form_type: "Type de Champ de Formulaire Supplémentaire",
  select_form_type: "Sélectionner type de champ supplémentaire",
  plce_contract_name: "Saisir nom du contrat",
  plce_parties_name: "Saisir nom des parties",
  plce_parties_desc: "Saisir description des parties",
  plce_form_name: "Saisir nom du formulaire",
  select_contract_type: "Sélectionner type de contrat",
  details: "Détails",
  preview: "Aperçu",
  noDataMsg: "Aucune Donnée",
  extra_details: "Détails Supplémentaires",
  comments_activity: "Commentaire/Activités",
  no_contracts: "Aucun Contrat",
  Inprogress: "En cours",
  historical_Services: "Services Historiques",
  Template_details: "Détails du Modèle",
  activities: "Activités",
  company_signatory: "Signataire de l'Entreprise",
  parties: "Parties",
  abort: "Abandonner",
  re_open: "Rouvrir",
  nickName: "Surnom",
  nickName_rule: "Veuillez saisir le surnom",
  registeredAddress: "Adresse Enregistrée",
  plce_nickName: "Saisir surnom",
  plce_registeredAddress: "Saisir adresse enregistrée",
  registeredAddress_rule: "Veuillez saisir l'adresse d'enregistrement",
  content_types_contract_type: "Type de Contrat",
  verify_contract: "Vérifier Contrat",
  relation_list: "Liste de Relations",
  create_relation_list: "Créer Formulaire de Relation",
  relation_form: "Formulaire de Relation",
  nickname_same_as_above_name: "Surnom identique au nom ci-dessus ?",
  registerd_address_same_as_above: "Adresse enregistrée identique à celle ci-dessus?",
  terminate: "Terminer",
  addendum: "Avenant",
  create_addendum: "Créer avenant",
  fill_template: "Remplir modèle",
  addendumName: "Nom",
  renew_contract: "Renouveler Contrat",
  Default_View: "Vue Grille",
  vendor_view: "Vue Fournisseur",
  my_contract: "Mon contrat",
  contract_details: "Détails du Contrat",
  reviewer: "Réviseur",
  vendor_name: "Nom du Fournisseur",
  parent_contract_name: "Nom du Contrat Parent",
  review: "Révision",
  add_review: "Ajouter Révision",
  review_comp: "Révision Complète",
  draft: "Brouillon",
  in_progress: "En Cours",
  userName: "Nom d'Utilisateur",
  GDD: "Détails Google Drive",
  reviewer_name: "Nom du Réviseur",
  address1: "Adresse1",
  address2: "Adresse2",
  country: "Pays",
  country_rule: "Sélectionner pays",
  plce_country: "Veuillez sélectionner le pays",
  state: "État",
  select_state: "Sélectionner état",
  plce_state: "Veuillez sélectionner l'État",
  city: "Ville",
  select_city: "Sélectionner Ville",
  plce_city: "Veuillez sélectionner la Ville",
  version: "Version",
  please_select_version: "Veuillez sélectionner la version",
  Select_version: "Sélectionner version",
  version_preview: "Aperçu de Version",
  storageType_rule: "Veuillez sélectionner le Type de Stockage",
  content_req_change: "Changements Demandés du Contenu",
  comment_list: "Liste de Commentaires",
  timeZone: "Fuseau horaire",
  verify: "Vérifier",
  timeZone_rule: "Veuillez sélectionner le fuseau horaire",
  plce_country_timezone: "Sélectionner fuseau horaire",
  connect_to: "Se connecter à",
  reconnect_to: "Se connecter",
  ok: "Ok",
  reasonArr: "Erreur",
  confirm_content: "Confirmer contenu",
  address_2: "Ligne d'Adresse2",
  contract_verification: "Avez-vous besoin de vérification de contrat ?",
  contract_count: "Avez-vous besoin de comptage de contrat ?",
  setcontract_count: "Saisir limite de Contrat",
  content_count: "Avez-vous besoin de comptage de contenu ?",
  setcontent_count: "Saisir limite de Contenu",
  contentLibrary_count: "Avez-vous besoin de comptage de bibliothèque de contenu ?",
  setcontentLibrary_count: "Saisir limite de bibliothèque de contenu",
  select_storages: "Sélectionner stockages",
  select_contract_limit: "Le contrat est-il limité ?",
  sethistorical_count: "Saisir limite de Contrat Historique",
  select_historicalcontract_limit: "Le contrat historique est-il limité ?",
  hiscontract_count: "Avez-vous besoin de comptage de contrat historique ?",
  staff_count_limit: "Avez-vous besoin de réviseurs limités ?",
  template_count_limit: "Avez-vous besoin de modèles limités ?",
  workflow_count_limit: "Avez-vous besoin de flux de travail limités ?",
  vendor_count_limit: "Avez-vous besoin de fournisseurs limités ?",
  signatory_count_limit: "Avez-vous besoin de signataires limités ?",
  settemplate_count_: "Saisir limite de Modèle",
  setvendor_count_: "Saisir limite de Fournisseur",
  setworkflow_count_: "Saisir limite de Flux de travail",
  setsignatory_count_: "Saisir limite de Signataire",
  select_staffcount_limit: "Le réviseur est-il limité ?",
  setstaff_count_: "Saisir limite de Réviseur",
  resend_code: "Renvoyer Code",
  otp_required: "OTP requis",
  otp_description: "Veuillez saisir le code de vérification qui est envoyé à votre adresse email",
  is_guest_user: "Se connecter en tant qu'Utilisateur Invité",
  License: "Licence",
  licence_name: "Nom du plan",
  licensing_features: "Fonctionnalités de licence",
  planpackages: "Plans",
  no_list: "Aucune Liste",
  plans: "Mon plan",
  termination_date: "Date de résiliation",
  execution_status: "Statut d'exécution",
  plce_parties_add: "Adresse du client",
  cp_address: "Adresse de la contrepartie",
  cp_name: "Nom de la contrepartie",
  cp_detail: "Détails de la contrepartie",
  your_role: "Votre rôle",
  cp_business_type: "Type d'activité de la contrepartie",
  client_name: "Nom du client",
  client_address: "Adresse du client",
  extra_delete_titte: "Êtes-vous sûr de supprimer ce formulaire supplémentaire?",
  guest_user: "Utilisateur Invité",
  last7Days: "7 Derniers Jours",
  last30Days: "30 Derniers Jours",
  currentMonth: "Mois Actuel",
  lastMonth: "Mois Dernier",
  last3Months: "3 Derniers Mois",
  last6Months: "6 Derniers Mois",
  Oneyear: "1 Dernière Année",
  obligation: "Obligation",
  create_obligation: "Créer obligation",
  myobligation: "Mon obligation",
  step_4: "Étape 4",
  assign_to: "Assigner à",
  slaType: "SLA",
  update_obligation: "Mettre à jour obligation",
  adobe: "Adobe",
  signature: "Signature",
  select_signatures: "Sélectionner signature",
  obligation_Services: "Services d'Obligation",
  onbgname_rule: "Veuillez saisir le nom de l'obligation",
  slatype_type_rule: "Veuillez sélectionner l'accord de niveau de service",
  please_select_obligationForm: "Veuillez sélectionner le formulaire d'obligation",
  create_obligation_form: "Créer formulaire d'obligation",
  attachment_rule: "Veuillez ajouter une pièce jointe",
  accept: "Accepter",
  frequency_type_rule: "Sélectionner fréquence",
  staff_assignee: "Personnel Assigné",
  please_add_reject_comment: "Veuillez ajouter un commentaire",
  please_add_reject_comment_empty: "Le commentaire ne peut pas être vide",
  Contractclause: "Clause de contrat",
  add_rejection_comment: "Ajouter commentaire",
  obligation_delete_title_workflow: "Êtes-vous sûr de vouloir supprimer cette obligation?",
  frequency: "Fréquence",
  obligation_delete_title: "Êtes-vous sûr de vouloir supprimer cette Obligation?",
  obligationform_delete_titte: "Êtes-vous sûr de vouloir supprimer ce formulaire d'Obligation?",
  activity: "Activité",
  department: "Département",
  plz_select_dept: "Veuillez sélectionner le département",
  select_dept: "Sélectionner département",
  enter_limit: "Saisir Limite",
  phone_limit: "Veuillez saisir une limite valide",
  financial_limit: "Signe de Limite Financière",
  chat: "Chat",
  plan_delete_title: "Êtes-vous sûr de vouloir supprimer ce plan?",
  content_lib: "Bibliothèque de Contenu",
  import_content: "Importer Contenu",
  pick_content_from: "Sélectionner Contenu de la Bibliothèque",
  Docusign: "Docusign",
  Reviewer_title_req: "Combien de réviseurs internes sont requis ?",
  approval_title_req: "Combien de signataires sont requis ?",
  renewalName: "Nom de Renouvellement",
  task_id: "Id de Tâche",
  cname_emptyrule: "Le nom de l'entreprise ne peut pas être une chaîne vide",
  email_emptyrule: "L'email ne peut pas être une chaîne vide",
  designation_emptyrule: "La désignation ne peut pas être une chaîne vide",
  firstname_emptyrule: "Le prénom ne peut pas être une chaîne vide",
  lastname_emptyrule: "Le nom de famille ne peut pas être une chaîne vide",
  registeredAddress_emptyrule: "L'adresse ne peut pas être une chaîne vide",
  nickName_emptyrule: "Le surnom ne peut pas être une chaîne vide",
  obligations: "Obligations",
  date: "Date",
  task_no: "N° de Tâche",
  plce_select_content_type: "Sélectionner type",
  please_content_type_rule: "Veuillez sélectionner le type de contenu",
  id: "Identifiant",
  contract_no: "N° de Contrat",
  sign_delete_title: "Êtes-vous sûr de vouloir supprimer la signature?",
  googledrive_delete_confirm_title: "Êtes-vous sûr de vouloir supprimer le Stockage Google? À partir de maintenant, votre contrat sera stocké dans le stockage par défaut.",
  clause_lib: "Bibliothèque de Clauses",
  create_clause: "Créer Clause",
  update_clause: "Mettre à jour Clause",
  clause: "Clause",
  last_modified: "Dernière Modification",
  plce_clauseDescription: "Décrire le type de clause",
  plce_clauseName: "Nommer le type de clause, ex. Amendement, Médiation etc.",
  clause_delete_title: "Êtes-vous sûr de vouloir supprimer cette Clause?",
  fields: "Champs",
  clauseDescription_rule: "Veuillez décrire la clause",
  clauseName_rule: "Veuillez saisir le nom de la clause",
  forgot_password_: "Mot de passe oublié",
  request: "Demande(s)",
  signout: "Se déconnecter",
  Contact_sales: "Contacter les Ventes",
  all: "Tout",
  unread: "Non lu",
  contractType: "Type de Contrat",
  create_contractType: "Créer Type de Contrat",
  express_contract: "Contrat Express",
  datamanager: "Gestionnaire de Données",
  display_name: "Nom d'Affichage",
  datatype: "Type de Données",
  unassign_delete_title: "Êtes-vous sûr de vouloir désassigner ce contrat?",
  bulk_assign_modal_title: "Assignation en Lot aux Associés Juridiques",
  delete_duplicates: "Supprimer les Doublons",
  delete_duplicate: "Supprimer le Doublon",
  counterparty: "Contrepartie",
  import_addendum: "Importer Avenant",
  contract_admin: "Administrateur de Contrat",
  user_admin: "Administrateur d'Utilisateur",
  contract_management: "Gestion de Contrat",
  welcome: "Bienvenue",
  setting: "Paramètres",
  companyPlansHeading: 'Détails du plan :-',
  companyPlansBasic: 'Basique',
  companyPlansExpiresOn: 'Expire le:-',

  // Individual item labels (singular)
  companyPlansContent: 'Contenu',
  companyPlansContents: 'Contenus',
  companyPlansContentInLibrary: 'Contenu Dans La Bibliothèque',
  companyPlansContentsInLibrary: 'Contenus Dans La Bibliothèque',
  companyPlansWorkflow: 'flux de travail',
  companyPlansWorkflows: 'flux de travail',
  companyPlansContract: 'contrat',
  companyPlansContracts: 'contrats',
  companyPlansHistoricalContract: 'contrat historique',
  companyPlansHistoricalContracts: 'contrats historiques',
  companyPlansReviewer: 'réviseur',
  companyPlansReviewers: 'réviseurs',
  companyPlansVendor: 'fournisseur',
  companyPlansVendors: 'fournisseurs',
  companyPlansSignatory: 'signataire',
  companyPlansSignatories: 'signataires',

  // Unlimited labels
  companyPlansUnlimitedContents: 'Contenus Illimités',
  companyPlansUnlimitedContentsLibrary: 'Contenus Illimités Dans La Bibliothèque',
  companyPlansUnlimitedWorkflow: 'Flux De Travail Illimité',
  companyPlansUnlimitedContracts: 'Contrats Illimités',
  companyPlansUnlimitedHistoricalContracts: 'Contrats Historiques Illimités',
  companyPlansUnlimitedReviewers: 'Réviseurs illimités',
  companyPlansUnlimitedVendors: 'Fournisseurs illimités',
  companyPlansUnlimitedSignatories: 'Signataires illimités',

  // Upto labels with dynamic values
  companyPlansUptoContent: 'Jusqu\'à {count} {type}',
  companyPlansUptoContentLibrary: 'Jusqu\'à {count} {type}',
  companyPlansUptoWorkflow: 'Jusqu\'à {count} {type}',
  companyPlansUptoContracts: 'Jusqu\'à {count} {type}',
  companyPlansUptoHistoricalContracts: 'Jusqu\'à {count} {type}',
  companyPlansUptoReviewers: 'Jusqu\'à {count} {type}',
  companyPlansUptoVendors: 'Jusqu\'à {count} {type}',
  companyPlansUptoSignatories: 'Jusqu\'à {count} {type}',

  // Feature access labels
  companyPlansAccessBulkTask: 'Accès Aux Tâches En Masse',
  companyPlansVerifyContracts: 'Vérifier Les Contrats',
  companyPlansStorageType: 'Type De Stockage ({storageTypes})',
  settingsTitle: 'Paramètres',
  settingsLanguageCardTitle: 'Paramètres De Langue',

  // Language selection
  settingsSelectLanguage: 'Sélectionner La Langue',
  settingsSelectLanguageDescription: 'Choisissez votre langue préférée pour l\'interface de l\'application',
  settingsSelectLanguagePlaceholder: 'Sélectionner une langue',

  // Language names
  settingsLanguageEnglish: 'English',
  settingsLanguageGerman: 'Deutsch',
  settingsLanguageFrench: 'Français',

  // Current selection
  settingsCurrentSelection: 'Sélection Actuelle',

  // Action buttons
  settingsSaveChanges: 'Enregistrer Les Modifications',
  settingsResetToDefault: 'Remettre Par Défaut',

  // Messages
 settingsLanguageSaveSuccess: "Langue modifiée avec succès !",
  explore: "Explorer",
  no_data_found: "Aucune donnée trouvée",
  esignservice:"Service de Signature Électronique",
  connected: "Connecté",
  not_connected: "Non connecté",
  weeks: "Semaines",
  days: "Jours",
  hours: "Heures",
  minutes: "Minutes",
  seconds: "Secondes",
  year: "Année",
  years: "Années",
  month: "Mois",
  months: "Mois",
  week: "Semaine",
  day: "Jour",
  hour: "Heure",
  minute: "Minute",
  second: "Seconde",
  and: "et",
  duration: "Durée",
  remaining: "Restant",
  expired_on: "Expiré le",
  digit_is_required: "chiffre est requis",
  set_duration: "Définir la Durée",
  please_enter_a_valid_limit: "Veuillez saisir une limite valide",
  enter_digit: "Saisir chiffre",
  storage: "Stockage",
  obligation_management: "Gestion des Obligations",
  grid_view: "Vue Grille",
  list_view: "Vue Liste",
 
  addendums: "Avenants",
  renewals: "Renouvellements",
  contract_family: "Famille de Contrats",
  archive:"Archiver",
  basic_details: "Détails de Base",
  contract_id:"Id de Contrat",
  counterparty_name: "Nom de la Contrepartie",
  counterparty_email: "Email de la Contrepartie",
  party_details: "Détails de la Partie",
  add: "Ajouter",
   no_addendum_are_available: "Aucun avenant n'est disponible",
   view_more: "Voir plus",
   overall_status: "Statut Global",
   company:"Entreprise",
   no_obligations_are_available: "Aucune obligation n'est disponible",
   contract_family: "Famille de Contrats",
   latest: "Dernier",

   no_renewal_are_available: "Aucun renouvellement n'est disponible",
   your_10_most_recent_notifications: "Vos 10 notifications les plus récentes",
   view_all: "Voir tout",
   notifications: "Notifications",
   no_notification_found: "Aucune notification trouvée",
   clear_all: "Tout effacer",
   artifact_status: "Statut de l'Artéfact",
   contract_types_count: "Nombre de Types de Contrats",
   contract_status:"Statut du Contrat",
   monthly_contract: "Contrat Mensuel",
   month: "Mois",
   contract_monthly_count: "Nombre de Contrats Mensuels",
   historical: "Historique",
   historical_contract_status:"Statut du Contrat Historique",
   graph:"Graphique",
   contract_graph:"Graphique de Contrat",
   staff_status:"Statut du Personnel",
   tasks:"Tâches",
   workflows:"Flux de travail",
   contents:"Contenus",
   terminated:"Terminé",
  contract_from:"Contrat De",
  normal_contracts:"Contrats Normaux",
  historical_contracts:"Contrats Historiques",
  analyse_risk_with_ai:"Analyser le Risque avec l'IA",
  create_linkage:"Créer un Lien",
  add_obligations:"Ajouter des Obligations",
  restructure:"Restructurer",
  linkage:"Lien",
table_search_placeholder: "Rechercher ...",
  table_filter_ok: "OK",
  table_filter_reset: "Réinitialiser",
  table_no_data: "Aucune donnée",
  table_pagination_items_per_page: "/ page",
  table_pagination_show_total: "{range0}-{range1} sur {total} éléments",
  workflow_suggestion: "Suggestion de workflow",
additional_notes: "Notes supplémentaires",
enter_any_extra_information_here: "Entrez toute information supplémentaire ici",
value: "Valeur",
contract_value: "Valeur du contrat",
which_type_of_department_is_used_for: "Quel type de département est utilisé pour ?",
additional_information: "Informations supplémentaires",
question: "Questions",
task_information: "Informations sur la tâche",
no_workflow_found: "Aucun workflow trouvé",
reviewandconfirm: "Vérifier et confirmer",
review_your_task: "Vérifiez votre tâche",
priority: "Priorité",
task_startdate: "Date de début de la tâche",
task_enddate: "Date de fin de la tâche",
task_description: "Description de la tâche",
select_files: "Sélectionner des fichiers",
clear_files: "Effacer les fichiers",
historical_contract_limit_exceeded: "Limite de contrat historique dépassée",
upload_record: "Télécharger l'enregistrement",
download_sample_contracts: "Télécharger des contrats d'exemple",
dont_have_handy_contracts_text: "Vous n'avez pas vos contrats sous la main ? Essayez d'importer nos contrats d'exemple.",
ai_smart_import_coming_soon: "Importation intelligente par IA (bientôt disponible)",
import_text_without_ai: "Téléchargez des fichiers sans utiliser l'IA pour étiqueter les données. L'IA sera utilisée pour l'OCR des documents afin de permettre une recherche avancée, et vous pourrez étiqueter manuellement les données après le téléchargement.",
add_more: "Ajouter plus",
selected: "Sélectionné",
drop_file_here: "Déposez les fichiers ici",
browse_files: "Parcourir les fichiers",
files: "fichiers",
or: "Ou",
import_from: "Importer depuis",
my_device: "Mon appareil",
drive: "Drive",
dropbox: "Dropbox",
onedrive: "OneDrive",
connect_to_google_drive: "Se connecter à Google Drive",
open_file_picker: "Ouvrir le sélecteur de fichiers",
ready: "Prêt",
empty: "Vide",
oversized: "Trop volumineux",
note: "Remarque",
do_not_upload_scanned_pdf: "Ne pas télécharger de PDF scannés",
supports_files_under: "Prend en charge les fichiers de moins de",
validfile: "Fichier valide",
invalidfile: "Fichier invalide",
import_from_google_drive: "Importer depuis Google Drive",
smart_import: "Importation intelligente",
save_time_by_using: "Gagnez du temps en utilisant",
smart_import_extra_text: "des modèles pour analyser le texte et détecter automatiquement les données clés lors du téléchargement. Les enregistrements seront instantanément consultables et filtrables",
export: "Exporter",
create_with: "Créer avec",
admin: "Administrateur",
select_content_from_library: "Sélectionner du contenu depuis la bibliothèque",
role_fields: "Champs de rôle",
custom_fields: "Champs personnalisés",
company_fields: "Champs de l'entreprise",
counterparty_fields: "Champs de la contrepartie",
contract_fields: "Champs du contrat",
help_box: "Boîte d'aide",
for_contract_fields: "pour les champs du contrat",
for_role_fields: "pour les champs de rôle",
use: "Utiliser",
sort_by_a_z: "Trier de A à Z",
sort_by_z_a: "Trier de Z à A",
sort_by_created_at: "Trier par date de création",
sort_by_updated_at: "Trier par date de mise à jour",
default: "Par défaut",
add_field: "Ajouter un champ",
add: "Ajouter",
import_addendum: "Importer un avenant",
cancel: "Annuler",
import: "Importer",
upload_pdf_only: "Veuillez télécharger uniquement des fichiers PDF !",
file_size_limit: "La taille du fichier doit être inférieure à 10 Mo !",
file_selected_successfully: "{filename} sélectionné avec succès !",
file_removed_successfully: "Fichier supprimé avec succès !",
upload_pdf_first: "Veuillez d'abord télécharger un fichier PDF",
click_or_drag_file_to_upload: "Cliquez ou glissez un fichier à télécharger",
support_pdf_max_size: "Supporte uniquement les fichiers PDF • Taille max : 10 Mo",
file_ready_to_submit: "Fichier sélectionné et prêt à être soumis",
preview: "Aperçu",
remove: "Supprimer",
click_or_drag_to_replace_file: "Cliquez ou glissez pour remplacer le fichier",
weekly: "Hebdomadaire",
monthly: "Mensuel",
quarterly: "Trimestriel",
yearly: "Annuel",
daily: "Quotidien",
obligation_no: "Obligation n°",
view_obligation_of: "Voir les obligations de",
contract_clause: "Clause du contrat",
currently_you_have_no_obligation_for_this_task: "Actuellement, vous n’avez aucune obligation pour cette tâche",
due_date: "Date d’échéance",
expiry: "Expiration",
waiting: "En attente",
accepted: "Accepté",
rejected: "Rejeté",
  attached_documents: "Documents joints",
attachments: "Pièces jointes",
dragger_upload_text: "Cliquez ou faites glisser un fichier dans cette zone pour le téléverser",
dragger_upload_hint: "Formats de fichiers pris en charge : PDF, PNG, JPG. Veuillez téléverser un fichier dans l’un de ces formats.",
uploading: "Téléversement en cours",
descriprion_rule: "Veuillez entrer une description valide",
add_documents: "Ajouter des documents",
enter_your: "Entrez votre",
contract_duration_rule: "Veuillez sélectionner la durée du contrat",
contract_expiry_rule: "Veuillez ajouter l’expiration du contrat",
click_to_upload: "Cliquez pour téléverser",
please_enter: "Veuillez entrer",
phone_rule_: "Le numéro de téléphone doit comporter entre 8 et 14 chiffres",
view_form: "Voir le formulaire",
fill_form: "Remplir le formulaire",
file_uploaded_successfully: "Fichier téléversé avec succès",
file_uploaded_failed: "Échec du téléversement du fichier",
file_supporting_message: "Seuls les fichiers PDF, JPG, JPEG et PNG sont autorisés !",
choose_content: "Choisir le contenu",
add_obligation: "Ajouter une obligation",
add_approver_rule: "Veuillez ajouter une approbation",
strategy_rule: "Sélectionnez au moins deux stratégies",
integration: "Intégration",
eSign: "Signature électronique",
back_to_integration: "Retour à l’intégration",
unlink_account: "Dissocier le compte",
link_account: "Lier le compte",
integration_status: "Statut de l’intégration",
connected_at: "Connecté le",
list_View: "Vue en liste",
approval_in_progress: "Approbation en cours",
approved: "Approuvé",
signature_inprogress: "Signature en cours",
update_accepted: "Mise à jour acceptée",
update_rejected: "Mise à jour rejetée",
update_completed: "Mise à jour terminée",
aborted: "Annulé",
internal_review: "Révision interne",
review_completed: "Révision terminée",
reviewed: "Révisé",
upload_xlsx_file: "Téléverser un fichier XLSX",
supportive_format_note: "Le format de fichier pris en charge est XLSX",
upload_format_tooltip: "Le fichier téléversé doit être au format XLSX",
update_obligation_form: "Mettre à jour le formulaire d'obligation",
number: "Nombre (123...)",
text: "Texte (Abc...)",
textarea: "Zone de texte",
decimal: "Décimal",
radio: "Bouton radio",
checkbox: "Case à cocher",
dropdown: "Liste déroulante",
datepicker: "Sélecteur de date",
  permission: "Permission",
  financial_limit_rule: "Veuillez entrer la limite financière",
  correct_email_warning: "Veuillez entrer l'adresse e-mail correcte",
  input_text_validation_message: "Seules les lettres, les chiffres et les espaces sont autorisés",
  enter_valid_name: "Entrez un nom valide",
  enter_valid_description: "Entrez une description valide",
  workflow_created_successfully: "Flux de travail créé avec succès !",
  workflow_success_subtitle: "Voulez-vous créer la tâche maintenant ou plus tard ?",
  later: "Plus tard",
  go_to_task: "Aller à la tâche",
  assign_now: "Attribuer maintenant",
  pagination_showTotal: "{start}-{end} sur {total} éléments",
    on: "Activé",
    off: "Désactivé",
    text_editor: "Éditeur de texte",
    unknown: "Inconnu",
    enter_defination: "Saisir la définition",
    definition: "Définition",
    definition_rule: "Veuillez saisir une définition",
    enter_property: "Saisir une propriété",
    property_key: "Clé de propriété",
    property_key_rule: "Veuillez saisir une clé de propriété",
    create_new_fields: "Créer un nouveau champ",
    update_field: "Mettre à jour le champ",
    field_name: "Nom du champ",
    field_rule: "Veuillez saisir le nom du champ",
    field_placeholder: "Saisir le nom du champ",
    select_datatype_rule: "Veuillez sélectionner un type de données",
     terminate_confirmation: "Êtes-vous sûr de vouloir résilier ce contrat ?",
    ai_analysis_failed: "Échec de l'analyse IA",
    day_s: "Jour(s)",
    Parent: "Parent",
    Child: "Enfant",
    ADDENDUM: "AVENANT",
    no_data_found: "Aucune donnée trouvée",
    assigned: "Attribué",
    signed: "Signé",
    please_select_at_least_one: "Veuillez en sélectionner au moins un",
    lifecycle_rule_text:"Veuillez remplir les champs des détails du cycle de vie",
extra_rule_text:"Veuillez remplir les champs des détails supplémentaires",
label_changed_successfully:"Libellé modifié avec succès",
model:"Modèle",
edit_prompt:"Modifier l'invite",
fill_with_ai:"Remplir avec l'IA",
lifecycle_detail:"Détails du cycle de vie",
parent_contract:"Contrat parent",
contract_type_rule:"Le type de contrat est requis",
phone_valid_rule:"Veuillez saisir un numéro de téléphone valide",
enter: "Entrer",
  task_no: "N° de tâche",
  contract: "Contrat",
  status: "Statut",
  assigned: "Assigné",
  completed: "Terminé",
  unassigned: "Non assigné",
  duplicate: "Doublon",
  duplicate_of: "Doublon de",
  assigned_to: "Assigné à",
  assigned_date: "Date d’assignation",
  submission_date: "Date de soumission",
  actions: "Actions",
  view: "Voir",
  edit: "Modifier",
  assign: "Assigner",
  reassign: "Réassigner",
  imported_on: "Importé le",
  remove_duplicates: "Supprimer les doublons",
  no_missing_contract: "Aucun contrat manquant trouvé",
  no_missing_contract_found: "Aucun contrat manquant trouvé",
  missing_contract: "Contrat manquant",
  find_missing_contract: "Trouver le contrat manquant",
  general_ai_prompt: "Invite IA générale",
  upload_info: "Téléverser des informations",
  bulk_reassign: "Réassignation en masse",
  bulk_assign: "Assignation en masse",
  assign_to_legal_associate: "Assigner à un juriste",
  total: "Total",
  all: "Tous",
  search: "Rechercher...",
  filter: "Filtrer",
  no_contracts: "Aucun contrat",
  ai_processing: "Traitement IA",
  finding_missing_contracts: "Recherche de contrats manquants...",

    imported: "Importé",
  duplicate: "Doublon",
  delete_duplicates: "Supprimer les doublons",
  delete_duplicate_records: "Supprimer les enregistrements en double",
  delete_duplicates_confirmation: "Êtes-vous sûr de vouloir supprimer {count} enregistrement(s) en double ?",
  cancel: "Annuler",
  found_duplicates_message: "Nous avons trouvé des doublons pour {count} enregistrement{count, plural, one {} other {s}}. Nous pouvons vous aider à supprimer les doublons tout en conservant les originaux.",
  ai_context_prompt: "Invite de contexte IA",
  please_input_ai_prompt: "Veuillez saisir une invite IA !",
  enter_detailed_prompt_for_ai_analysis: "Entrez une invite détaillée pour l'analyse par IA",
  
  ai_preview: "Aperçu IA",
  pdf_loaded_success: "Contrat PDF chargé avec succès",
  pdf_loading_error: "Erreur lors du chargement du PDF. Veuillez réessayer.",
  loading_pdf: "Chargement du PDF...",
  failed_to_load_pdf: "Échec du chargement du PDF",
  ai_suggestions: "Suggestions IA",
  show_highlights: "Afficher les surlignages",
  hide_all: "Tout masquer",
  side_all: "Tout côte à côte",
  page: "Page",
  copyright: "Droits d'auteur © {startYear}-{endYear}. Tous droits réservés.",
  select_content_rule: "Veuillez sélectionner un contenu",
  review_and_send: "Vérifier et envoyer",
  new_version_available_review: "Une nouvelle version est disponible. Veuillez la vérifier",
  collab: "Collaboration",
  more: "Plus",
  complete_review: "Terminer la révision",
  edit_info: "Modifier les infos",
  back: "Retour",
  dept: "Département",
  service_level_agrrement: "Accord de niveau de service",
  select_obligation_template: "Sélectionner un modèle d'obligation",
  please_select_obligation_template: "Veuillez sélectionner un modèle d'obligation"  ,

 non_collab: "Non collaboratif",

collab_active: "Le mode collaboratif est actif",
collab_inactive: "Le mode collaboratif est inactif",
collaborative: "Collaboratif",
missing_required_fields: "{count} champs obligatoires manquants",

approve_and_sign: "Approuver et signer",
need_assistance: "Besoin d'aide ? Visitez notre",
help_center: "Centre d'aide",
or_email: "ou envoyez un e-mail",
no_activities: "Aucune activité",
counterparty_information: "Informations sur la contrepartie",
counterparty_select_rule: "Veuillez sélectionner une contrepartie",
invite_via_email: "Inviter par e-mail",
vendor_limit_exceeded: "Limite de fournisseur dépassée selon votre plan. Veuillez modifier le plan si nécessaire",
change_expiry_label: "Voulez-vous modifier la date d'expiration ?",
contract_information: "Informations sur le contrat",
company_information: "Informations sur l'entreprise",
reviewer_information: "Informations sur le réviseur",
reviewer_select_rule: "Veuillez sélectionner un réviseur",
add_new: "Ajouter nouveau",
email_document: "Document par e-mail",
  cancel: "Annuler",
  send: "Envoyer",
  to: "À",
  cc: "Cc",
  subject: "Objet",
  draft_contract: "Projet de contrat",
  please_review: "Veuillez vérifier",
  dear: "Cher/Chère",
  reviewer: "Réviseur",
  signatory: "Signataire",
  you_have_been_added_as: "Vous avez été ajouté en tant que",
  in_the_following_contract: "dans le contrat suivant.",
  contract_name: "Nom du contrat",
  please_find_the_contract_attached: "Veuillez trouver le contrat joint à cet e-mail et vérifier les clauses du contrat. Si des ajouts ou modifications sont nécessaires, veuillez nous répondre à l'adresse e-mail de l'entreprise",
  best_regards: "Cordialement,",
  team: "Équipe",
  replies_appear_in_activity: "Les réponses à cet e-mail apparaîtront automatiquement dans le flux d'activité",
  processing: "Traitement",
parameterizing_field_text: "Nous paramétrons les champs dans le contenu",
if: "Si",
wait_moment: "Veuillez patienter un instant",
contract_success_message: "Félicitations ! Votre contrat a été créé avec succès",
go_to_my_contracts: "Aller à mes contrats",
obligation_expiry: "Expiration de l'obligation",
add_comment: "Ajouter un commentaire",
reviewer_count: "Nombre de réviseurs",
signatory_count: "Nombre de signataires",
sla_weekly_review: "Revue hebdomadaire",
sla_priority_standard: "Priorité standard",
sla_weekly_description: "Cette obligation nécessite une revue hebdomadaire.",

sla_monthly_check: "Vérification mensuelle",
sla_priority_routine: "Priorité de routine",
sla_monthly_description: "Cette obligation nécessite une vérification mensuelle.",

sla_quarterly_report: "Rapport trimestriel",
sla_priority_important: "Priorité importante",
sla_quarterly_description: "Cette obligation nécessite un rapport trimestriel.",

sla_annual_review: "Revue annuelle",
sla_priority_strategic: "Priorité stratégique",
sla_annual_description: "Cette obligation nécessite une revue annuelle.",

sla_daily_monitoring: "Suivi quotidien",
sla_priority_critical: "Priorité critique",
sla_daily_description: "Cette obligation nécessite un suivi quotidien.",

company_label: "Entreprise",
counterparty_label: "Contrepartie",

this_obligation: "cette obligation",
remove_confirmation_title: "Êtes-vous sûr de vouloir supprimer {name} ?",
remove_obligation_warning: "La suppression de cette obligation est irréversible.",
remove: "Supprimer",
cancel: "Annuler",
removed_successfully: "supprimée avec succès",
edit: "Modifier",

unnamed_obligation: "Obligation sans nom",
new_label: "Nouveau",
no_description_available: "Aucune description disponible",

obligations_ready_to_add: "obligations prêtes à être ajoutées",
please_add_obligation_before_submit: "Veuillez ajouter au moins une obligation avant de continuer.",
add_obligation: "Ajouter une obligation",
contract_obligations_management: "Gestion des obligations contractuelles",
adding_obligations_to_contract: "Ajout des obligations au contrat {name}",
document: "Document",
contract_content: "Contenu du contrat",
obligations_library: "Bibliothèque des obligations",
add_new: "Ajouter nouveau",
no_obligations_added_yet: "Aucune obligation n’a encore été ajoutée.",
click_add_new_to_create: "Cliquez sur 'Ajouter nouveau' pour créer des obligations.",
    assign_obligation: "Attribuer une obligation",
    please_select_one: "Veuillez en sélectionner une",
    enter_contract_clause: "Saisir une clause contractuelle",
    enter_clause: "Saisir une clause",
    select_obligation: "Sélectionner une obligation",
    already_used: "Déjà utilisé",
    obligation_template: "Modèle d’obligation",
lifecycle_info: "Infos sur le cycle de vie",
tag: "Étiquette",
    describe_why_field_is_use_for: "Décrivez à quoi sert le champ ?",
    option_duplicate_rule: "Les options ne peuvent pas être dupliquées",

  ongoing_review: "Révision en cours",
 view_checklist:"View Checklist",
  workflow_required_rule: "Veuillez saisir un nom de workflow",
    assign_contract: "Attribuer un contrat",
  reassign_contract: "Réattribuer un contrat",
  assign_contracts_text:
    "Attribuer {count} contrat(s) à un juriste",
  reassign_contracts_text:
    "Réattribuer {count} contrat(s) à un juriste",
  select_associate_rule: "Veuillez sélectionner un juriste",
  select_legal_associate: "Sélectionner un juriste",
  choose_associate: "Choisir un juriste",
  none: "Aucun",
  confirm_unassign: "Êtes-vous sûr de vouloir désattribuer ce contrat ?",
  confirm_assign_contracts:
    "Êtes-vous sûr de vouloir attribuer {count} contrat(s) à ce juriste ?",
   bulk_assign_modal_title: "Attribution groupée aux associés juridiques",
    select_assignment_method: "Sélectionner la méthode d’attribution",
    document_range: "Plage de documents",
    percentage_range: "Plage de pourcentage",
    range: "Plage",
    from_document: "Du document",
    to_document: "Au document",
    assign_to: "Attribuer à",
    reassign_to: "Réattribuer à",
    required: "Obligatoire",
    to_doc_greater: "Le document de fin doit être supérieur au document de début",
    ranges_overlap: "Les plages ne peuvent pas se chevaucher",
    create_range: "Créer une plage",
    cancel: "Annuler",
    assign: "Attribuer",
    reassign: "Réattribuer",
    warning_all_assigned: "Tous les documents sont déjà attribués",
    error_add_range: "Erreur lors de l’ajout d’une nouvelle plage",
    please_fill_required: "Veuillez remplir tous les champs obligatoires",
    check_all: "Tout cocher",
    verify_text_rule: "Vérifiez les détails en cliquant sur la case à cocher",
      input_must_50: "La saisie doit contenir 50 caractères ou moins.",
    new_chat: "Nouvelle discussion",
    ai_powered: "Propulsé par l'IA",
    ask: "Demander",
    type_a_message: "Tapez un message...",
    please_wait: "Veuillez patienter...",
     versions: "Versions",
  compare: "Comparer",
  no_version_yet: "Aucune version pour l’instant",
  with: "Avec",
  delete_comment_title: "Êtes-vous sûr de vouloir supprimer ce commentaire",
   filter_contracts: "Filtrer les contrats",
  legal_associate: "Associés juridiques",
  clear_filter: "Effacer le filtre",
  apply_filter: "Appliquer le filtre",
  export_record: "Exporter l’enregistrement",
  upload: "Téléverser",
  click_or_drag_file: "Cliquez ou faites glisser un fichier ici pour le téléverser",
  upload_hint: "Prise en charge d’un téléchargement unique ou multiple. Le téléchargement de données de l’entreprise ou d’autres fichiers interdits est strictement interdit.",
  file_selected: "fichier sélectionné",
  file_upload_failed: "Échec du téléversement du fichier.",
  only_xlsx_allowed: "Seuls les fichiers .xlsx sont autorisés !",
  error_reading_excel: "Échec de la lecture du fichier Excel. Veuillez vérifier le format.",
  analysis_report: "Rapport d'analyse",
  ai_analysing_text: "L’IA analyse le document",
  complete_review_document: "Document de révision complet",
  only_doc_allowed: "Seuls les fichiers .doc et .docx sont autorisés !",
  delete_comment: "Supprimer le commentaire",
  obligations_label_for_attach: "Voulez-vous ajouter des obligations à ce flux de travail ?",
 content_template: "Modèles de contenu",
   task_approved: "Tâche approuvée",
  out_for_signature: "Envoyé pour signature",
  go_back: "Retour",

}